import { hidesChatLauncher } from "@/app/navigation/full-screen-routes";
import type { PermissionSet } from "@/lib/permissions/permissions";
import { CHAT_MODULE, CHAT_PERMISSIONS } from "../api/chat.types";

/**
 * KÖŞEDEKİ SOHBET DÜĞMESİ NEREDE ÇİZİLİYOR — TEK KURAL, ÜÇ OKUYUCU.
 *
 * NEDEN (bağımsız inceleme, Sohbet 21). Aynı koşul üç yerde ayrı ayrı yazılıydı: düğmenin kendisi
 * (`ChatLauncherHost`), kabuğun `<main>` alt rezervi (`AppLayout`) ve yuvayı açma bağlamı
 * (`ChatDockProvider`, sohbet sayfasında isteği adrese çeviriyor). Biri değişip ötekiler
 * değişmezse düğme çizilir ama rezerv verilmez — ya da tersine, düğmesiz sayfada boşluk kalır.
 * Kural bir kez burada; üçü de bunu okuyor.
 */

/**
 * Sohbet SAYFASI mı — `/chat` ya da `/chat/:id`. Önek karşılaştırması değil: `/chatbot` gibi bir
 * gelecekteki adres sohbet sayfası sayılıp düğmeyi kaybetmesin.
 */
export function isChatPagePath(pathname: string): boolean {
  return pathname === "/chat" || pathname.startsWith("/chat/");
}

/** Sohbet bu kişi için var mı: modül kurulu ve okuma anahtarı elinde. */
export function chatReadable(permissions: Pick<PermissionSet, "can" | "isModuleEnabled">): boolean {
  return permissions.isModuleEnabled(CHAT_MODULE) && permissions.can(CHAT_PERMISSIONS.read);
}

/**
 * Bu adreste köşede düğme YOK — iki sebep:
 *
 * - sohbet sayfası: konuşma zaten ekranda;
 * - köşesi gömülü bir çerçevenin olan tam ekran rota (belge düzenleyici, 18 Eylül 2026): düğme
 *   Collabora'nın yakınlaştırma denetimlerini örtüyordu. Liste `full-screen-routes.ts`'te, `<main>`
 *   rezervinin okuduğu listenin AYNISI.
 *
 * Yuvayı açma isteği bu adreslerde sohbet sayfasına gidiyor (`ChatDockProvider`): düğmesi olmayan
 * sayfada bir istek açılacak yuva bulamaz ve «Canlı yardım» ölü bir düğme olurdu.
 */
export function chatLauncherHiddenOn(pathname: string): boolean {
  return isChatPagePath(pathname) || hidesChatLauncher(pathname);
}

/** Köşedeki düğme bu adreste çiziliyor mu: sohbet bu kişi için var ve adres onu gizlemiyor. */
export function chatLauncherVisible(input: {
  permissions: Pick<PermissionSet, "can" | "isModuleEnabled">;
  pathname: string;
}): boolean {
  return chatReadable(input.permissions) && !chatLauncherHiddenOn(input.pathname);
}
